<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{ header }}</h5>
    </div>
    <b-form @submit.prevent="onSubmit()">
      <div
        class="form-row">
        <div class="form-group col-md-6">
          <label for="input_password">New Password</label>
          <input
            id="input_password"
            name="password"
            type="password"
            v-model.lazy="form.password"
            class="form-control"
            :class="{'is-invalid': errors.has('password')}"
            v-validate="'required'"
            placeholder="Password">
          <b-form-feedback>{{ errors.first('password') }}</b-form-feedback>
        </div>
        <div class="form-group col-md-6">
          <label for="input_password2">New Password confirmation</label>
          <input
            name="confirm password"
            type="password"
            v-model.lazy="form.password2"
            :class="{'is-invalid': errors.has('confirm password')}"
            class="form-control"
            id="input_password2"
            v-validate="'confirmed:password'"
            placeholder="Password confirmation">
          <b-form-feedback>{{ errors.first('confirm password') }}</b-form-feedback>
        </div>
      </div>
      <hr>
      <b-button
        type="submit"
        id="createBtn"
        :disabled="disabled"
        variant="primary">
        <span v-if="beforeClick">Save changes</span>
        <span v-else> Loading..</span>
        <i v-if="loadingSpinner" class="fa fa-spinner fa-spin"></i>
      </b-button>
      <b-button
        @click="onCancel()"
        type="reset"
        variant="outline-secondary"
        class="pull-right">Cancel</b-button>
    </b-form>
  </b-card>
</template>
<script>
import { log } from 'util';

export default {
  name: 'update_password',
  data() {
    return {
      form: {
        id: null,
        password: '',
        password2: '',
      },
      loadingSpinner: false,
      beforeClick: true,
      disabled: false,
    };
  },
  created() {
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'profile', name: 'Profile' },
      { to: 'update_password', name: 'Update Password' },
    ];
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  computed: {
    getId() {
      return this.$store.getters.userData.id;
    },
    header() {
      const header = 'Update password';
      return header;
    },
  },
  watch: {
  },
  methods: {
    onSubmit() {
      this.validate().then((valid) => {
        if (valid && !this.isDuplicateUsername) {
          this.loadingSpinner = true;
          this.beforeClick = false;
          this.disabled = true;
          this.form.id = this.getId;
          this.$store.dispatch('users/UPDATE_DATA', this.form).then((user) => {
            log(user);
            this.$router.push('/profile');
          });
        } else {
          this.loadingSpinner = false;
          this.beforeClick = true;
          this.disabled = false;
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      this.$router.push('/profile');
    },
  },
};
</script>
<style lang="sass">
.unavailable
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #f86c6b;
.available
  display: none;
</style>




// WEBPACK FOOTER //
// src/views/pages/profile/detail/UpdatePassword.vue